import { QuestionnaireResponse } from "@medplum/fhirtypes";

import { isValid, parseISO } from "date-fns";

import { compareMetaVersionIdDesc } from "@/utils/observation-recency";

/**
 * Parses an ISO-8601 instant to epoch milliseconds, or undefined when invalid/missing.
 */
export function parseIsoInstant(iso: string | undefined): number | undefined {
  if (!iso) return undefined;
  const parsed = parseISO(iso);
  if (!isValid(parsed)) return undefined;
  return parsed.getTime();
}

/**
 * Best-effort instant when a QuestionnaireResponse version was materialized (for amendment windowing).
 */
export function getQuestionnaireResponseChangeInstant(
  questionnaireResponse: QuestionnaireResponse,
): number | undefined {
  return (
    parseIsoInstant(questionnaireResponse.meta?.lastUpdated) ??
    parseIsoInstant(questionnaireResponse.authored)
  );
}

/**
 * Sort comparator for QuestionnaireResponse history: newest `meta.versionId` first (UUID7 string order).
 */
export function compareQuestionnaireResponsesByVersionIdDesc(
  firstQuestionnaireResponse: QuestionnaireResponse,
  secondQuestionnaireResponse: QuestionnaireResponse,
): number {
  return compareMetaVersionIdDesc(
    firstQuestionnaireResponse.meta?.versionId,
    secondQuestionnaireResponse.meta?.versionId,
  );
}
